// @ts-strict-ignore
import React from 'react';

import {LocalizationStore} from 'common/i18n/store';
import {ToggleReact} from 'common/components/toggle';
import {ToggleTheme} from 'common/components/toggle/types';
import {ListOperator} from 'common/widgets/property-filter-menu/models/types';

export function CohortSelection(props: {
  value?: ListOperator;
  onChange: (value: ListOperator) => void;
  i18n: LocalizationStore;
}) {
  return (
    <div className='mp-filter-menu-header is-visible'>
      <ToggleReact
        className='mp-filter-menu-cohort-options'
        selected={props.value ?? ListOperator.Contains}
        theme={ToggleTheme.SegmentedController}
        options={[
          {
            label: props.i18n.t(`filters.cohort-operator.is`),
            value: ListOperator.Contains,
          },
          {
            label: props.i18n.t(`filters.cohort-operator.is-not`),
            value: ListOperator.DoesNotContain,
          },
        ]}
        onSelect={(ev) => props.onChange(ev.detail.selected as ListOperator)}
      />
    </div>
  );
}
